import { render } from "./FragenblockModal.vue?vue&type=template&id=1a9c672c&ts=true"
import script from "./FragenblockModal.vue?vue&type=script&lang=ts"
export * from "./FragenblockModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__